<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />

    <v-card>
      <v-card-title>契約者詳細</v-card-title>
      <v-row class="pr-2">
        <v-col class="text-right reload_contractor">
          <v-btn
            v-if="(contractor.contract_unit_type === 'paid_examination' || contractor.contract_unit_type === 'formally_contract') &&
              contractor.payment_type === 'payment_contractor' && contractor.paid_id === null"
            color="success"
            style="text-transform: none"
            @click="connectPaidContractorButtonClickEvent"
          >
            Paid連携する
          </v-btn>
          &nbsp;
          <v-btn
            v-if="contractor.contract_unit_type !== 'paid_examination'"
            color="info"
            @click="launchMailButtonClick"
          >
            <v-icon>mdi-plus</v-icon>&nbsp;開通メールを送信する
          </v-btn>
        </v-col>
      </v-row>

      <v-card-text>
        <!-- 運用モード -->
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              運用モード
            </div>
            <h4>{{ contractor.jw_mode }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /運用モード -->

        <!-- 法人コード -->
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              法人コード
            </div>
            <h4>{{ contractor.code }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /法人コード -->

        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              法人名
            </div>
            <h4>{{ contractor.name }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              法人名フリガナ
            </div>
            <h4>{{ contractor.name_kana }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div class="overline">
              住所
            </div>
            <h4>
              〒{{contractor.zip_code}}&nbsp;{{ contractor.address }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              代表者名
            </div>
            <h4>{{ contractor.representative_name }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              代表者名フリガナ
            </div>
            <h4>{{ contractor.representative_name_kana }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              担当者名
            </div>
            <h4>{{ contractor.supervisor_name }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              担当者名フリガナ
            </div>
            <h4>{{ contractor.supervisor_name_kana }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              申込担当者部署名
            </div>
            <h4>{{ contractor.supervisor_department_name }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              DXEサービス&emsp;最終ログイン日時
            </div>
            <h4>{{ contractor.corporate_manager_last_logged_in_at }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              申込担当者電話番号
            </div>
            <h4>{{ contractor.supervisor_phone_number }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              申込担当者FAX番号
            </div>
            <h4>{{ contractor.supervisor_fax_number }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              申込担当者メールアドレス
            </div>
            <h4>{{ contractor.supervisor_email }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              契約単位種別
            </div>
            <h4>{{ contractor.contract_unit_type_name }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col v-if="contractor.contract_unit_type === 'paid_examination' || contractor.contract_unit_type === 'formally_contract'"
            cols="12" md="3"
          >
            <div class="overline">
              請求単位
            </div>
            <h4>{{ contractor.invoice_type_name }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col v-if="((contractor.contract_unit_type === 'paid_examination' || contractor.contract_unit_type === 'formally_contract') && contractor.invoice_type === 'month') "
            cols="12" md="3"
          >
            <div class="overline">
              初期費用利用
            </div>
            <h4>{{ contractor.use_initial_cost }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              申込日
            </div>
            <h4>{{ contractor.contract_date | date_format }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div class="overline">
              備考
            </div>
            <div style="overflow-y: auto;overflow-x: hidden;max-height: 13vh; white-space: pre-line;">
              <h4>{{ contractor.remarks }}</h4>&nbsp;
            </div>
            <v-divider />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              支払種別
            </div>
            <h4>{{ contractor.payment_type_name }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col
            v-if="contractor.payment_type === 'payment_contractor'"
            cols="12" md="3"
          >
            <div class="overline">
              支払方法種別
            </div>
            <h4>{{ contractor.payment_method_type_name }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="6" md="3">
            <div class="overline">
              開通メール送信日時
            </div>
            <h4>{{ contractor.mail_send_at }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>

        <v-row
          v-if="contractor.paid_id !== null"
        >
          <v-col cols="12" md="3">
            <div class="overline" style="text-transform: none">
              Paid ID
            </div>
            <h4>{{ contractor.paid_id }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col
            cols="12" md="3"
          >
            <div class="overline" style="text-transform: none">
              Paid連携日時
            </div>
            <h4>{{ contractor.paid_connect_at }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col
            cols="12" md="3"
          >
            <div class="overline" style="text-transform: none">
              Paid連携利用
            </div>
            <h4>{{ contractor.use_paid }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div>
              <v-card
                v-for="tenant in contractor.tenants_attributes"
                :key="tenant.id"
              >
                <v-card-title>
                  テナント詳細
                  <v-col
                    v-if="(contractor.contract_unit_type === 'paid_examination' || contractor.contract_unit_type === 'formally_contract') &&
                      contractor.payment_type === 'payment_tenant' && tenant.paid_id === null &&
                      !tenant.service_stop"
                    class="text-right"
                  >
                    <v-btn
                      color="success"
                      style="text-transform: none"
                      @click="connectPaidTenantButtonClickEvent(tenant.id)"
                    >
                      Paid連携する
                    </v-btn>
                  </v-col>
                </v-card-title>
                <v-card-text class="my-5">
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        配車計画利用有無
                      </div>
                      <h4>{{ tenant.use_allocate }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>

                  <!-- 売上請求管理 -->
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        売上請求管理利用
                      </div>
                      <h4>{{ tenant.use_billing }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>
                  <!-- /売上請求管理 -->

                  <!-- 利用モード -->
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        利用モード
                      </div>
                      <h4>{{ tenant.mode_name }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>
                  <!-- /利用モード -->

                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        テナントコード
                      </div>
                      <h4>{{ tenant.code }}</h4>
                      <v-divider />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6">
                      <div class="overline">
                        テナント名
                      </div>
                      <h4>{{ tenant.name }}</h4>
                      <v-divider />
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="overline">
                        テナント名フリガナ
                      </div>
                      <h4>{{ tenant.name_kana }}</h4>
                      <v-divider />
                    </v-col>
                  </v-row>

                  <v-card-subtitle>{{ tenant.mode === 'disposal' ? '代表処分加入者' : '収運加入者' }}</v-card-subtitle>
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        加入者番号
                      </div>
                      <h4>{{ tenant.subscriber_number }}</h4>
                      <v-divider />
                    </v-col>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        公開確認番号
                      </div>
                      <h4>{{ tenant.confirmation_number }}</h4>
                      <v-divider />
                    </v-col>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        EDI利用確認キー
                      </div>
                      <h4>{{ tenant.edi_usage_key }}</h4>
                      <v-divider />
                    </v-col>
                  </v-row>

                  <br />
                  <template>
                    <v-card
                      v-if="tenant.mode_name === '収運・処分'"
                      outlined
                      style="max-height: 30vh;overflow-y: scroll;"
                    >
                      <v-card-subtitle>処分加入者</v-card-subtitle>
                      <template
                        v-for="disposal in tenant.disposal_subscribers_attributes"
                      >
                        <v-card-text
                          v-if="!disposal._destroy"
                          :key="disposal.key"
                        >
                          <v-row
                            dense
                          >
                            <v-col cols="12" md="3">
                              <div class="overline">
                                加入者番号
                              </div>
                              <h4>{{ disposal.subscriber_number }}</h4>
                              <v-divider />
                            </v-col>
                            <v-col cols="12" md="3">
                              <div class="overline">
                                公開確認番号
                              </div>
                              <h4>{{ disposal.confirmation_number }}</h4>
                              <v-divider />
                            </v-col>
                            <v-col cols="12" md="3">
                              <div class="overline">
                                EDI利用確認キー
                              </div>
                              <h4>{{ disposal.edi_usage_key }}</h4>
                              <v-divider />
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </template>
                    </v-card>
                  </template>

                  <br />
                  <!-- 利用モード -->
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        他社区間代行起票
                      </div>
                      <h4>{{ tenant.use_proxy_entry }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>
                  <!-- /利用モード -->
                  <br />
                  <template>
                    <v-card
                      v-if="tenant.proxy_entry_subscribers_attributes && tenant.proxy_entry_subscribers_attributes.length > 0"
                      outlined
                      style="max-height: 30vh;overflow-y: scroll;"
                    >
                      <v-card-subtitle>他社区間代行起票 収運加入者</v-card-subtitle>
                      <template
                        v-for="transport in tenant.proxy_entry_subscribers_attributes"
                      >
                        <v-card-text
                          v-if="!transport._destroy"
                          :key="transport.key"
                        >
                          <v-row
                            dense
                          >
                            <v-col cols="12" md="3">
                              <div class="overline">
                                他社法人名
                              </div>
                              <h4>{{ transport.name }}</h4>
                              <v-divider />
                            </v-col>
                            <v-col cols="12" md="3">
                              <div class="overline">
                                加入者番号
                              </div>
                              <h4>{{ transport.subscriber_number }}</h4>
                              <v-divider />
                            </v-col>
                            <v-col cols="12" md="3">
                              <div class="overline">
                                公開確認番号
                              </div>
                              <h4>{{ transport.confirmation_number }}</h4>
                              <v-divider />
                            </v-col>
                            
                          </v-row>
                        </v-card-text>
                      </template>
                    </v-card>
                  </template>

                  <v-row>
                    <v-col>
                      <div class="overline">
                        住所
                      </div>
                      <h4>
                        〒{{tenant.zip_code}}&nbsp;{{ tenant.address }}&nbsp;
                      </h4>
                      <v-divider />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        担当者名
                      </div>
                      <h4>{{ tenant.supervisor_name }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        担当者名フリガナ
                      </div>
                      <h4>{{ tenant.supervisor_name_kana }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="overline">
                        担当者部署名
                      </div>
                      <h4>{{ tenant.supervisor_department_name }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        担当者電話番号
                      </div>
                      <h4>{{ tenant.supervisor_phone_number }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        担当者FAX番号
                      </div>
                      <h4>{{ tenant.supervisor_fax_number }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="overline">
                        担当者メールアドレス
                      </div>
                      <h4>{{ tenant.supervisor_email }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        IP制限の利用有無
                      </div>
                      <h4>{{ tenant.use_ip_restrictions }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>
                  
                  <v-row>
                    <v-col cols="12" md="6">
                      <div class="overline">
                        許可するIPアドレス
                      </div>
                      <h4>{{ tenant.allowed_ip_addresses }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        APIの利用有無
                      </div>
                      <h4>{{ tenant.use_api }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        freeeの請求連携利用有無
                      </div>
                      <h4>{{ tenant.use_freee_claim }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        JWNETデータ取込の利用有無
                      </div>
                      <h4>{{ tenant.use_jwnet_transfer }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        再資源法令適用
                      </div>
                      <h4>{{ tenant.use_recycling }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>

                  <v-card-title>請求情報（基本料金）</v-card-title>
                  <v-row>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        正式契約日
                      </div>
                      <h4>{{ tenant.formally_contract_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        請求開始日
                      </div>
                      <h4>{{ tenant.invoice_start_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        請求無料期間
                      </div>
                      <h4>{{ tenant.invoice_free_term }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>
                  
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        料金プラン
                      </div>
                      <h4>{{ tenant.price_plan_name }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      v-if="contractor.payment_type === 'payment_tenant'"
                      cols="12" md="3"
                    >
                      <div class="overline">
                        支払方法種別
                      </div>
                      <h4>{{ tenant.payment_method_type_name }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額利用料金
                      </div>
                      <h4>{{ tenant.saas_monthly_price | comma_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額料金改定日
                      </div>
                      <h4>{{ tenant.saas_price_rev_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額改定利用料金
                      </div>
                      <h4>{{ tenant.saas_monthly_rev_price | comma_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>

                  <v-row
                    v-if="tenant.paid_id !== null"
                  >
                    <v-col cols="12" md="3">
                      <div class="overline" style="text-transform: none">
                        Paid ID
                      </div>
                      <h4>{{ tenant.paid_id }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col cols="12" md="3">
                      <div class="overline" style="text-transform: none">
                        Paid連携日時
                      </div>
                      <h4>{{ tenant.paid_connect_at }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline" style="text-transform: none">
                        Paid連携利用
                      </div>
                      <h4>{{ tenant.use_paid }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        サービス利用停止日
                      </div>
                      <h4>{{ tenant.service_stop_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>

                  <v-card-title>請求情報（電子契約）</v-card-title>
                  <!-- 電子契約利用開始日・電子契約利用終了日・電子契約請求開始日・電子契約請求無料期間 -->
                  <v-row>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        電子契約利用開始日
                      </div>
                      <h4>{{ tenant.ec_contract_start_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        電子契約利用終了日
                      </div>
                      <h4>{{ tenant.ec_contract_end_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        請求開始日
                      </div>
                      <h4>{{ tenant.ec_contract_invoice_start_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        請求無料期間
                      </div>
                      <h4>{{ tenant.ec_contract_invoice_free_term }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>
                  <!-- 電子契約料金プラン・電子契約月額利用料金・月額料金改定日・月額改定利用料金 -->
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        料金プラン
                      </div>
                      <h4>{{ tenant.ec_contract_price_plan_name }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額利用料金
                      </div>
                      <h4>{{ tenant.ec_contract_monthly_price | comma_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額料金改定日
                      </div>
                      <h4>{{ tenant.ec_contract_price_rev_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額改定利用料金
                      </div>
                      <h4>{{ tenant.ec_contract_monthly_rev_price | comma_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>
                  <v-card-title>請求情報（IPアドレス制限）</v-card-title>
                  <!-- IPアドレス制限利用開始日・IPアドレス制限利用終了日・IPアドレス制限請求開始日・IPアドレス制限請求無料期間 -->
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        IPアドレス制限利用開始日
                      </div>
                      <h4>{{ tenant.ip_restrictions_formally_contract_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        IPアドレス制限利用終了日
                      </div>
                      <h4>{{ tenant.ip_restrictions_service_stop_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        請求開始日
                      </div>
                      <h4>{{ tenant.ip_restrictions_invoice_start_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        請求無料期間
                      </div>
                      <h4>{{ tenant.ip_restrictions_invoice_free_term }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>
                  <!-- IPアドレス制限料金プラン・IPアドレス制限月額利用料金・月額料金改定日・月額改定利用料金 -->
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        料金プラン
                      </div>
                      <h4>{{ tenant.ip_restrictions_price_plan_name }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額利用料金
                      </div>
                      <h4>{{ tenant.ip_restrictions_monthly_price | comma_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額料金改定日
                      </div>
                      <h4>{{ tenant.ip_restrictions_price_rev_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額改定利用料金
                      </div>
                      <h4>{{ tenant.ip_restrictions_monthly_rev_price | comma_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>
                  <v-card-title>請求情報（API）</v-card-title>
                  <!-- API利用開始日・API利用終了日・API請求開始日・API請求無料期間 -->
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        API利用開始日
                      </div>
                      <h4>{{ tenant.api_start_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        API利用終了日
                      </div>
                      <h4>{{ tenant.api_end_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        請求開始日
                      </div>
                      <h4>{{ tenant.api_invoice_start_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        請求無料期間
                      </div>
                      <h4>{{ tenant.api_invoice_free_term }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>
                  <!-- API料金プラン・API月額利用料金・月額料金改定日・月額改定利用料金 -->
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        料金プラン
                      </div>
                      <h4>{{ tenant.api_price_plan_name }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額利用料金
                      </div>
                      <h4>{{ tenant.api_monthly_price | comma_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額料金改定日
                      </div>
                      <h4>{{ tenant.api_price_rev_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額改定利用料金
                      </div>
                      <h4>{{ tenant.api_monthly_rev_price | comma_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>

                  <v-card-title>freee請求連携</v-card-title>
                  <!-- freee利用開始日・freee利用終了日・freee請求開始日・freee請求無料期間 -->
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        freee利用開始日
                      </div>
                      <h4>{{ tenant.freee_start_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        freee利用終了日
                      </div>
                      <h4>{{ tenant.freee_end_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        請求開始日
                      </div>
                      <h4>{{ tenant.freee_invoice_start_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        請求無料期間
                      </div>
                      <h4>{{ tenant.freee_invoice_free_term }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>
                  <!-- freee料金プラン・freee月額利用料金・月額料金改定日・月額改定利用料金 -->
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        料金プラン
                      </div>
                      <h4>{{ tenant.freee_price_plan_name }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額利用料金
                      </div>
                      <h4>{{ tenant.freee_monthly_price | comma_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額料金改定日
                      </div>
                      <h4>{{ tenant.freee_price_rev_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額改定利用料金
                      </div>
                      <h4>{{ tenant.freee_monthly_rev_price | comma_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row> 

                  <v-card-title>請求情報（JWNETデータ取込）</v-card-title>
                  <!-- JWNET取込利用開始日・JWNETデータ取込利用終了日・JWNETデータ取込請求開始日・JWNETデータ取込請求無料期間 -->
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        JWNETデータ取込利用開始日
                      </div>
                      <h4>{{ tenant.jwnet_transfer_start_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        JWNETデータ取込利用終了日
                      </div>
                      <h4>{{ tenant.jwnet_transfer_end_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        請求開始日
                      </div>
                      <h4>{{ tenant.jwnet_transfer_invoice_start_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        請求無料期間
                      </div>
                      <h4>{{ tenant.jwnet_transfer_invoice_free_term }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>
                  <!-- JWNETデータ取込料金プラン・JWNETデータ取込月額利用料金・月額料金改定日・月額改定利用料金 -->
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        料金プラン
                      </div>
                      <h4>{{ tenant.jwnet_transfer_price_plan_name }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額利用料金
                      </div>
                      <h4>{{ tenant.jwnet_transfer_monthly_price | comma_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額料金改定日
                      </div>
                      <h4>{{ tenant.jwnet_transfer_price_rev_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額改定利用料金
                      </div>
                      <h4>{{ tenant.jwnet_transfer_monthly_rev_price | comma_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>

                  <v-card-title>請求情報（他社区間代行起票）</v-card-title>
                  <!-- 他社区間代行起票利用開始日・終了日・他社区間代行起票請求開始日・請求無料期間 -->
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        他社区間代行起票利用開始日
                      </div>
                      <h4>{{ tenant.proxy_entry_start_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        他社区間代行起票利用終了日
                      </div>
                      <h4>{{ tenant.proxy_entry_end_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        請求開始日
                      </div>
                      <h4>{{ tenant.proxy_entry_invoice_start_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        請求無料期間
                      </div>
                      <h4>{{ tenant.proxy_entry_invoice_free_term }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>
                  <!-- 他社区間代行起票料金プラン・月額利用料金・月額料金改定日・月額改定利用料金 -->
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="overline">
                        料金プラン
                      </div>
                      <h4>{{ tenant.proxy_entry_price_plan_name }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額利用料金
                      </div>
                      <h4>{{ tenant.proxy_entry_monthly_price | comma_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額料金改定日
                      </div>
                      <h4>{{ tenant.proxy_entry_price_rev_date | date_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12" md="3"
                    >
                      <div class="overline">
                        月額改定利用料金
                      </div>
                      <h4>{{ tenant.proxy_entry_monthly_rev_price | comma_format }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>
                  <!-- 他社区間代行起票条件 -->
                  <v-row>
                    <v-col>
                      <div class="overline">
                        条件
                      </div>
                      <h4>{{ tenant.proxy_entry_condition }}&nbsp;</h4>
                      <v-divider />
                    </v-col>
                  </v-row>

                  <!-- その他金額・その他請求適用日・その他タイトル -->
                  <v-card-title>請求情報（その他請求）</v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col>
                        <v-data-table
                          :headers="tableHeaders"
                          :items="tenant.invoice_others_attributes"
                          :items-per-page="-1"
                          hide-default-footer
                          disable-pagination
                          disable-sort
                        >
                          <template v-slot:[`item.others_price`]="{ item }">
                            {{ (item.others_price === null ? null : parseFloat(item.others_price)) | comma_format }}
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-card-text>

                </v-card-text>
              </v-card>
            </div>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="error"
          @click="deleteButtonClickEvent"
        >
          削除
        </v-btn>
        <v-spacer />
        <v-btn
          @click="cancelButtonClickEvent"
        >
          閉じる
        </v-btn>
        <v-btn
          color="primary"
          @click="editButtonClickEvent"
        >
          編集する
        </v-btn>
      </v-card-actions>
    </v-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import {mapActions} from 'vuex'
import Confirm from '../../../components/Confirm'
export default {
  name: 'AdminContractor',
  components: {
    Confirm
  },
  mixins: [],
  data () {
    return {
      breadcrumbs: [
        { text: '契約者一覧', disabled: false, to: '/admin/contractors', exact: true },
        { text: '契約者詳細', disabled: true, to: '' },
      ],
      // その他金額は右寄せ、その他請求適用日は中央寄せとする
      tableHeaders: [
        { value: 'others_price', text: 'その他金額', align: 'right' },
        { value: 'others_invoice_date', text: 'その他請求適用日', align: 'center' },
        { value: 'others_title', text: 'その他タイトル' },
      ],
      total_count: null,
      contractor: {}
    }
  },
  created() {
    /**
     * @typedef content { Object }
     * @property contract_unit_type { String }
     * @property payment_type { String }
     * @property representative_name { String }
     * @property representative_name_kana { String }
     * @property supervisor_name { String }
     * @property supervisor_name_kana { String }
     * @property corporate_manager_last_logged_in_at { String }
     * @property contract_unit_type_name { String }
     * @property invoice_type_name { String }
     * @property contract_date { String }
     * @property remarks { String }
     * @property payment_type_name { String }
     * @property payment_method_type_name { String }
     * @property mail_send_at { String }
     * @property tenants_attributes { Array }
     *  @property service_stop { Boolean }
     *  @property price_plan_name { String }
     */
    this.fetchContractor({ id: this.$route.params.id }).then((content) => {
      this.contractor = content
    })
  },
  methods: {
    ...mapActions('AdminContractor', {
      fetchContractor: 'show',
      deleteContractor: 'destroy',
      sendMail: 'sendOpeningMail',
    }),
    ...mapActions('ConnectPaidContactor', {
      connectPaidContractor: 'create',
    }),
    ...mapActions('ConnectPaidTenant', {
      connectPaidTenant: 'create',
    }),
    launchMailButtonClick () {
      let modalOption = { title: 'メール送信', message: '契約者の申込担当者宛にメールを送信します。よろしいですか？', options: { titleColor: 'blue' } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.sendMail({id: this.contractor.id})
        }
      })
    },
    cancelButtonClickEvent () {
      this.$router.push({name: 'AdminContractors'})
    },
    editButtonClickEvent () {
      this.$router.push({name: 'AdminContractorEdit', params: {id: this.contractor.id}})
    },
    deleteButtonClickEvent () {
      let modalOption = { title: '削除', message: '契約者を削除します。よろしいですか？', options: { titleColor: 'red' } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteContractor({id: this.contractor.id }).then(() =>{
            this.$router.push({name: 'AdminContractors'})
          })
        }
      })
    },
    // 契約者のPaid連携
    connectPaidContractorButtonClickEvent () {
      // 確認メッセージ
      let modalOption = { title: 'Paid連携', message: '契約者のPaid登録を行います。よろしいですか？', options: { titleColor: 'blue' } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.connectPaidContractor({id: this.contractor.id}).then((result) => {
            this.contractor.paid_id = result.paid_id
            this.contractor.paid_connect_at = result.paid_connect_at
          })
        }
      })
    },
    // テナントのPaid連携
    connectPaidTenantButtonClickEvent (tenant_id) {
      // 確認メッセ-ジ
      let modalOption = { title: 'Paid連携', message: 'テナントのPaid登録を行います。よろしいですか？', options: { titleColor: 'blue' } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.connectPaidTenant({contractor_id: this.contractor.id, tenant_id: tenant_id}).then((result) => {
            for (const tenant of this.contractor.tenants_attributes) {
              if(tenant.id === tenant_id){
                tenant.paid_id = result.paid_id
                tenant.paid_connect_at = result.paid_connect_at
              }
            }
          })
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.theme--light.v-divider {
  border-color: rgba(0,0,0,0.12) !important;
}
</style>
